otuApp.errorState=0;

window.addEventListener("unload", function (e) {
	// if we were playing the catchAWave game and it is no longer visible and it was a two player game make sure we give up..
	if (catchAWave.connectIsGameOn()) {
		console.log('Catch A Wave - Window Unload Event Catch A Wave Game given up');
		if (catchAWave.connectIsMaster())
			catchAWave.connectEmitGameState( {newStates:['MASTER_GIVE_UP']});	
		if (catchAWave.connectIsSlave1())
			catchAWave.connectEmitGameState( {newStates:['SLAVE1_GIVE_UP']});	
		catchAWave.giveUp();
	}
});

// cancel the sys messages
$(document).ready(function() {
	$('a[data-action="sys-modal-cancel"]').click(function (e) {
		$('.sys-message-modal').stop(true,true);
		$('.sys-message-modal').hide();
		$('.sys-message-modal .sys-message').hide();
		// make sure we stop all animations
		$('*').stop(true,true);
		// maybe we should do an appStateRefresh too!
	});
});


window.onerror = function myErrorHandler(errorMsg, url, lineNumber,col,object) {
	// we are going to ignore script errors on line 0 as the are created by vimeo or any other external script
	// I suspect vimeo test for a certain way to inject their script into the player and it fails on ios.
	
	if ( errorMsg=='Script error.' && lineNumber===0 && col===0) return true;
	
	otuApp.errorState=1;
	otuApp.errorMessage=errorMsg;

	var stack = ( object.stack ? object.stack : 'Stack not supported');

	if (reportError({'errorMsg':errorMsg, 'scriptUrl':url,'lineNumber':lineNumber,'columnNumber':col, 'object':object, 'stack' : stack  },otuApp.appState.lastPath + otuApp.appState.lastQuery)) {

		console.log('Error - Showing user error feedback screen');
		//$('.sys-message-modal').stop(true);
		$('.sys-message-modal .sys-message').hide();
		//$('.sys-message-modal .custom').html(errorMsg + ': line: ' + lineNumber + ' url ' + url + ' col ' + col + ' ' +  JSON.stringify(object));
		$('.sys-message-modal').addClass('bg-black-transparent');
		$('.sys-message-modal').show();
		$('.sys-message-modal .javascript-error').show();
		$('.sys-message-modal .custom').show();
		$('.sys-message-modal .message-buttons').show();
	}
	
}

global.printMessages = function (messages,options) {
	$('.messagesArea').empty();
	$.each(messages, function( type, value ) {
		  console.log( type  );
		  $.each(value, function (index,message) {
			  $('.messagesArea').append('<div class="' + type + '">' + message + '</div>');
		  });
		});
}

global.stackTrace =function() {
    var err = new Error();
    return err.stack;
}


global.sendReport = function () {
	reportError(
			{
				errorMsg:"Send Report Event",
			},
			null);	
}

global.reportError = function (errorObj, request) {

	const getCircularReplacer = () => {
    //form a closure and use this 
    //weakset to monitor object reference.
    const seen = new WeakSet();
    
    //return the replacer function
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '[circular]'
            }
            seen.add(value);
        }
        return value;
    };
	};
	
	
	/* 
	 * there are some error we ignore one is the bouncemarker error, it does not seem to affect anything.
	 * 
	 */

	if (typeof errorObj!='undefined') {
	
		if (typeof errorObj.scriptUrl!='undefined') {
			if (errorObj.scriptUrl.includes("bouncemarker.js")) {
				console.log('Error - BOUNCEMARKER ERROR --- TAKE ACTION ? this._map is undefined');
				return false;
			}
		}

		if (typeof errorObj.errorMsg!=='undefined') {
			switch (errorObj.errorMsg) {
				case 'ResizeObserver loop limit exceeded':
					return false;
				default:
			}
		};
		
	
	}




	if (typeof otuApp.appState.templateParams!='undefined') {
		if (typeof otuApp.appState.templateParams.noJsErrorReporting!='undefined') {
			if (otuApp.appState.templateParams.noJsErrorReporting) return true;
		}
	}
	
	var data={};


	console.log('Error - Reporting error back to server');

	if (typeof navigator!=='undefined') errorObj.agent=navigator.userAgent;
	errorObj.buildVersionInfo=otuApp.buildVersionInfo;
	data.errorObj=JSON.stringify(errorObj);
	if (typeof myConsole!=='undefined') {
		data.appLog=JSON.stringify(myConsole.history(),getCircularReplacer());
	}
	data.request=request;
	console.log(data);
	var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=app.reportError';
	otuApp.triggerAjaxPost(url,data,{'noSysInteraction':true,debug:false});

	// track error page with piwik

	_paq.push(["setDocumentTitle", 'ERROR - ' + errorObj.errorMsg]);	
	_paq.push(["setCustomUrl",  otuApp.appState.rootUrl + 'error']);
	_paq.push(["trackPageView"]);

	return true;
}

global.reportFeedback = function(options) {
	var feedback=$('#'+ options.id).val();
	var reason = otuApp.errorMessage;

	if (typeof feedback=='undefined'|| feedback.trim()=='') {
		console.log('Error - No feedback given.')
		return;
	}	
	console.log('Reporting Feedback to Server.')

	$('.sys-feedback-wrapper').html('<div class="sys-feedback-sending">Sending Feedback...</div>');

	var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=app.reportFeedback';

	otuApp.triggerAjaxPost(url,{
			feedback:feedback,
			reason: reason
		},
		{
			'noSysInteraction':true,
			debug:false,
			callback:function(){
				$('.sys-feedback-wrapper').html('<div class="sys-feedback-thanks">Thank you!</div>');
			}});



}

global.recoverFromError = function () {
	otuApp.errorState=0;
	otuApp.errorMessage=null;
	$('.sys-message-modal').hide();
}

global.testJsError =function () {
	throw new Error("Just a fake error to test the reporting...");
}

global.isDebugUser=function() {
	var debug=false;
	
	return otuApp.appUser.debug;
	
	/*
	if (typeof appUser !=='undefined')
		if (otuApp.appUser.json !== null)
			if (typeof otuApp.appUser.json.debug!=='undefined')
				return otuApp.appUser.json.debug;
	return false;
	*/
}